import { StandardLoanDetails } from '../../../../../queries/standardLoanQueries';
import { emptyPropertyForm, PropertyForm } from '../constants/propertyForm';

/** A loaded loan's properties, in order; one empty property when it has none (as EditStdLoanModal shows). */
export const getPropertiesFromLoan = (loan: StandardLoanDetails): PropertyForm[] => {
    const properties = loan.properties ?? [];
    if (properties.length === 0) {
        return [emptyPropertyForm];
    }

    return properties.map((property, index) => ({
        id: property.id || undefined,
        // EditStdLoanModal keeps the suffix equal to the property's position
        bfiNumberSuffix: property.bfiNumberSuffix ?? index + 1,
        commitment: property.commitment ?? undefined,
        originationFee: property.originationFee ?? undefined,
    }));
};
